import React, { useContext } from 'react';
import { useI18n } from '@oneaudi/i18n-context';
import { Popover } from '@oneaudi/unified-web-components';
import type { AudiHeaderDealerProps } from '../../interfaces/header-components.interfaces';
import { StyledIconButton } from './AudiHeaderDealerContextStyles';
import { messages } from '../../i18n/messages';
import { DealerContext } from '../../context';
import { NAVIGATION_CLASSNAME } from '../../utils/globals';
import AudiHeaderAdditionalDealerDataAlpha from './AudiHeaderAdditionalDealerData_alpha';
import { truncate } from '../../utils/string-utils';
import styled from 'styled-components';

const StyledButtonContainer = styled.div`
  cursor: pointer;
`;

const AudiHeaderDealerContextAlpha: React.FC<AudiHeaderDealerProps> = ({
  isMobileView = false,
  onClickDealerContext,
  showDealerAdditionalData,
}) => {
  const { dealerData } = useContext(DealerContext);

  const showDealerInfo = useI18n(messages.dealer_info);
  const hideDealerInfo = useI18n(messages.hide_dealer_info);
  const dealerButtonLabel = showDealerAdditionalData ? hideDealerInfo : showDealerInfo;
  const buttonLabel = !isMobileView
    ? truncate(dealerData?.additionalData?.displayName || dealerData?.name)
    : dealerData?.additionalData?.displayName || dealerData?.name || 'Name not found';

  return (
    <>
      {!isMobileView ? (
        <Popover
          content={
            <AudiHeaderAdditionalDealerDataAlpha
              open={showDealerAdditionalData}
              isMobileView={isMobileView}
              refDealerData={null}
            />
          }
          data-testid="dealerContext-test-id"
          id="dealerContext"
          onClose={onClickDealerContext}
          triggerElement={
            <StyledButtonContainer onClick={onClickDealerContext}>
              <StyledIconButton
                aria-label={dealerButtonLabel}
                data-testid="dealer-data-toggle"
                icon={showDealerAdditionalData ? 'cancel' : 'poi-active'}
                id="dealerButton"
                label={buttonLabel}
                onClick={onClickDealerContext}
                size="sm"
                variant="tertiary"
                className={NAVIGATION_CLASSNAME}
              />
            </StyledButtonContainer>
          }
          withTip={false}
          open={showDealerAdditionalData}
          alignment="center"
          placement="top"
        />
      ) : null}
    </>
  );
};

export default AudiHeaderDealerContextAlpha;
